<template>
  <section class="buy section">
    <div class="title-line line">
      <h2 class="title-strat"><slot /></h2>
    </div>
    <div class="content">
      <OfferItem
        :offer="offer"
        class="offer-bloc"
        flexible
        :from-section="true"
      />
      <div class="more">
        <p>Découvrez toutes nos offres du moment</p>
        <ButtonSimple
          route="/offres"
          label="Découvrir"
          color="white"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { CustomSimpleOffer } from '~/types/'

defineProps<{ offer: CustomSimpleOffer }>()
</script>

<style lang="scss" scoped>
.buy {
  .content {
    display: flex;
    justify-content: space-between;

    .more {
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      justify-content: center;
      align-items: flex-start;
      width: 35rem;
      height: 59rem;
      margin-left: 2rem;
      padding-right: 6.5rem;
      padding-left: 4.5rem;
      background: $blue;

      p {
        margin-bottom: 4.4rem;
        color: $white;
        font-size: 3.2rem;
        line-height: 4.1rem;
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .buy {
    .content {
      .more {
        flex-shrink: 0;
        width: 48%;
        margin-left: 2%;
        padding-right: 4.5rem;
      }
    }
  }
}

@media screen and (max-width: 700px) {
  .buy {
    display: block;
    margin-top: 5rem;
    padding-left: 2.5rem;

    .title-line {
      padding-left: 0;
    }

    .content {
      display: block;

      .offer-bloc {
        width: 100%;
      }

      .more {
        display: block;
        width: 100%;
        height: auto;
        margin-left: 0;
        padding: 2.5em;
      }
    }
  }
}
</style>
